import { all } from 'redux-saga/effects'

import { faqSaga } from './faq/sagas'

export function* immigrateSaga() {
  yield all([faqSaga()])
}
